var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M220.318,249.429c23.785,0,47.57,0,71.353,0l0.39,4.877l-34.87,52.863l-37.458-53.385l0.584-4.352 L220.318,249.429L220.318,249.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0BA7D"
    },
    d: "M220.778,236.169l-0.618,29.819l-50.59,27.664v101.405h85.164h85.153V293.651l-47.016-29.223 l-2.582-29.814l-69.51,1.554H220.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M197.401,149.212c0,0-2.901-6.374-10.689-3.215c-7.79,3.155,0.35,34.651,3.327,39.045 c2.974,4.392,7.763,1.603,9.507,1.429c2.48,18.776,2.701,31.717,10.217,39.634c7.119,7.496,23.417,22.773,32.003,28.101 c5.815,1.228,10.153,1.949,14.234,2.165c4.079-0.216,8.421-0.939,14.234-2.165c8.585-5.325,24.886-20.605,32.003-28.101 c7.514-7.917,7.737-20.855,10.217-39.634c1.744,0.175,6.533,2.963,9.507-1.429c2.976-4.394,11.117-35.891,3.327-39.045 c-7.79-3.16-10.689,3.215-10.689,3.215s7.699-24.733-5.986-49.078c-9.378-16.686-30.767-25.34-52.612-25.975 c-21.845,0.635-43.234,9.289-52.612,25.975c-13.685,24.346-5.986,49.078-5.986,49.078L197.401,149.212L197.401,149.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M195.351,274.76l12.115-4.772l9.763-8.773l34.472,26.145h8.585l34.483-26.176l21.874,13.579 l38.011,64.61l-30.103,163.323c-21.821,6.052-44.809,9.3-68.558,9.3c-19.369,0-38.23-2.165-56.368-6.24L145.67,344.535 l49.678-69.774L195.351,274.76z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M305.588,266.591l-13.917-17.162l-31.381,37.932l26.936,29.93L305.588,266.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M206.384,266.289l13.935-16.86l31.383,37.932l-28.006,29.622L206.384,266.289z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.386,266.289l-92.244,29.997c-3.751,1.217-6.107,4.407-6.871,8.279L80.146,442.023 c18.267,17.275,39.08,31.878,61.813,43.21l13.485-44.009c0.157-0.505,0.637-0.82,1.162-0.757c0.523,0.062,0.921,0.481,0.95,1.01 l1.947,51.688c29.781,12.135,62.355,18.831,96.499,18.831v-17.162L206.388,266.29L206.386,266.289z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M206.386,266.289l-10.565,3.246l-27.99,47.759l35.335,1.107l-21.693,12.351l74.53,164.084 l-49.614-228.545L206.386,266.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M305.588,266.591l92.272,29.695c3.757,1.209,6.105,4.407,6.869,8.279l27.126,137.46 c-18.269,17.275-39.083,31.879-61.817,43.212l-13.487-44.011c-0.155-0.505-0.64-0.82-1.162-0.757 c-0.523,0.062-0.917,0.483-0.948,1.01l-1.942,51.688c-29.781,12.135-62.355,18.831-96.497,18.831H256v-17.162l49.587-228.242 L305.588,266.591z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M305.588,266.591l5.865,1.784l32.693,49.22l-35.335,1.109l21.695,12.352l-74.506,163.78 l49.587-228.242v-0.002H305.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DADA"
    },
    d: "M266.455,493.762c-3.111,0-5.633,2.516-5.633,5.616c0,3.105,2.524,5.62,5.633,5.62 c3.109,0,5.633-2.516,5.633-5.62C272.088,496.276,269.564,493.762,266.455,493.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M307.877,156.576l5.428-0.19l1.747-6.194l5.113-5.102c3.377-25.428,4.372-65.003-20.867-63.861 c0,0-2.276-28.856-47.801-23.2c-45.528,5.658-66.098,35.048-63.647,59.568c2.449,24.52,1.462,27.49,1.462,27.49l5.113,5.104 l0.771,7.046l4.465-0.282c0,0,1.4-9.431,2.801-13.579c1.402-4.147,0.963-12.543,0.963-12.543s53.774,3.426,68.306-15.059 c8.975-11.415,29.587-31.194,30.625-3.802c0.308,8.123-2.712,20.298,3.067,29.159c5.781,8.862,2.452,15.443,2.452,15.443h0.002 V156.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M256,494.834l14.536-66.904l-9.878-131.88l5.382-2.297l-5.753-6.391h-8.585l-5.9,6.242l5.538,2.447 l-9.631,132.947l14.292,65.837L256,494.834L256,494.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.954,493.762c-2.833,0-5.133,2.29-5.133,5.115c0,2.828,2.299,5.12,5.133,5.12 c2.831,0,5.133-2.291,5.133-5.12C271.087,496.053,268.785,493.762,265.954,493.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M346.395,409.066c-9.99-1.725-16.69-11.223-14.967-21.21c1.725-9.988,11.223-16.693,21.21-14.969 c9.99,1.725,16.69,11.225,14.967,21.215c-1.725,9.987-11.223,16.69-21.212,14.965L346.395,409.066L346.395,409.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M346.576,408.012c-9.408-1.625-15.718-10.565-14.093-19.976c1.625-9.409,10.568-15.72,19.978-14.097 c9.408,1.625,15.718,10.57,14.093,19.978c-1.625,9.411-10.568,15.718-19.978,14.093V408.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBECEC"
    },
    d: "M347.89,400.405c-5.204-0.897-8.696-5.85-7.799-11.055c0.897-5.206,5.85-8.696,11.053-7.799 c5.206,0.899,8.698,5.845,7.799,11.053c-0.897,5.204-5.848,8.696-11.053,7.799V400.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M349.015,382.577l4.203,0.726l2.26-13.09l-4.203-0.726L349.015,382.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M208.24,412.697l7.876-1.563c3.347-0.666,6.118-2.635,7.887-5.279 c1.764-2.644,2.531-5.957,1.865-9.305l-9.263-46.667c-3.497-17.61-17.273-26.59-33.015-28.581 c-6.032-0.763-12.356-0.485-18.483,0.728c-6.132,1.213-12.076,3.369-17.357,6.376c-13.754,7.834-23.023,21.378-19.522,39.016 l9.263,46.669c0.666,3.347,2.639,6.116,5.281,7.885l0.007-0.002c2.644,1.769,5.953,2.531,9.3,1.867l7.872-1.563l-0.644-3.246 l-7.874,1.563c-2.454,0.487-4.885-0.075-6.822-1.367l0.002-0.002c-1.938-1.298-3.386-3.329-3.874-5.781l-9.263-46.669 c-3.177-16.005,5.316-28.341,17.901-35.504c4.974-2.835,10.583-4.868,16.373-6.017c5.79-1.147,11.752-1.406,17.434-0.688 c14.409,1.821,27.009,9.981,30.178,25.955l9.265,46.669c0.485,2.452-0.077,4.881-1.371,6.822c-1.298,1.936-3.329,3.384-5.784,3.869 l-7.876,1.563l0.644,3.246v0.005H208.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M219.104,356.799l-1.415-7.128c-3.603-18.156-17.777-27.41-33.961-29.459 c-6.149-0.776-12.589-0.498-18.831,0.741c-6.242,1.235-12.301,3.435-17.682,6.497c-14.146,8.056-23.674,22.002-20.064,40.19 l1.417,7.128l5.406-1.076l-1.415-7.128c-3.067-15.458,5.168-27.393,17.361-34.336c4.874-2.774,10.37-4.765,16.047-5.891 c5.675-1.127,11.52-1.38,17.087-0.677c13.961,1.764,26.167,9.65,29.232,25.082l1.415,7.128l5.408-1.074L219.104,356.799z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#076673"
    },
    d: "M153.704,424.235l4.214-0.837c1.058,1.187,2.695,1.796,4.363,1.466 c2.507-0.498,4.136-2.932,3.638-5.441c-0.496-2.505-2.932-4.134-5.439-3.636c-1.672,0.33-2.95,1.521-3.472,3.021l-4.211,0.835 l0.91,4.59L153.704,424.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#076673"
    },
    d: "M211.588,412.746l-4.209,0.837c-0.523,1.499-1.801,2.688-3.47,3.021 c-2.507,0.496-4.941-1.131-5.439-3.64c-0.496-2.505,1.131-4.941,3.636-5.437c1.669-0.33,3.308,0.282,4.361,1.466l4.211-0.837 L211.588,412.746z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M167.458,320.532l-1.607-8.096l-3.195,0.635l-3.191,0.633l1.625,8.176 c1.217-0.355,2.449-0.657,3.693-0.904C165.67,320.799,166.56,320.654,167.458,320.532z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M160.566,419.73c0.758-0.15,1.251-0.89,1.1-1.645c-0.15-0.759-0.884-1.253-1.645-1.103 c-0.759,0.15-1.251,0.888-1.1,1.645c0.151,0.757,0.886,1.253,1.645,1.1V419.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M202.219,411.446c0.757-0.15,1.248-0.888,1.098-1.643c-0.15-0.761-0.884-1.253-1.645-1.103 c-0.759,0.15-1.251,0.888-1.1,1.647C200.72,411.105,201.458,411.597,202.219,411.446z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M347.379,400.317c-4.923-0.849-8.224-5.53-7.376-10.456c0.849-4.921,5.527-8.224,10.451-7.373 c4.923,0.849,8.226,5.53,7.376,10.451c-0.851,4.923-5.532,8.226-10.453,7.378H347.379z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M206.431,268.717c-0.141,0.002-49.86,0.414-41.462,43.912l-4.624,0.884 c-9.467-49.038,45.874-49.49,46.031-49.492L206.431,268.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M305.643,264.243c8.112,0.219,23.792,2.43,35.862,17.111c11.811,14.367,20.091,40.752,13.9,89.128 l-4.661-0.589c5.993-46.822-1.751-72.032-12.865-85.554c-10.859-13.211-25.018-15.202-32.343-15.399l0.11-4.697L305.643,264.243z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.e5b639aa40eec985df27184bd35fd630.svg";
export { ForwardRef as ReactComponent };